import {
  Box,
  MenuItem,
  Select,
  SxProps,
  Theme,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import TranslateIcon from "@mui/icons-material/Translate";

export const getLanguageString = (lang: string) => {
  if (lang === "en-US") {
    return "English";
  } else if (lang === "zh-TW") {
    return "繁體中文";
  } else if (lang === "zh-CN") {
    return "简体中文";
  } else if (lang === "ja") {
    return "日本語";
  } else if (lang === "ko") {
    return "한국어";
  } else if (lang === "th") {
    return "ภาษาไทย";
  } else if (lang === "vi") {
    return "Tiếng Việt";
  } else if (lang === "id") {
    return "Indonesia";
  } else if (lang === "fil") {
    return "Filipino";
  }
};

export const suppoertedLanguages = [
  "zh-TW",
  "zh-CN",
  "en-US",
  "ja",
  "ko",
  "th",
  "vi",
  "id",
  "fil",
];

const LanguageSelector = ({
  color = "white",
  sx,
}: {
  sx?: SxProps<Theme>;
  color?: string;
}) => {
  const { i18n } = useTranslation();
  const handleLanguageChange = (lang: string) => {
    i18n.changeLanguage(lang);
  };

  return (
    <Select
      value={i18n.language}
      onChange={(e) => handleLanguageChange(e.target.value)}
      displayEmpty
      renderValue={() => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            color: color,
            mr: "8px",
          }}
        >
          <TranslateIcon />
          <Typography>{getLanguageString(i18n.language)}</Typography>
        </Box>
      )}
      sx={{
        ...sx,
        boxShadow: "none",
        ".MuiOutlinedInput-notchedOutline": { border: 0 },
        "& .MuiSelect-icon": { color: color },
        color: color,
      }}
    >
      {suppoertedLanguages.map((lang) => (
        <MenuItem
          key={lang}
          value={lang}
          sx={{ display: lang !== i18n.language ? "block" : "none" }}
        >
          {getLanguageString(lang)}
        </MenuItem>
      ))}
    </Select>
  );
};

export default LanguageSelector;
